import type { SimpleUser, User } from '@common/types/objects';

export const CORE_ADD_MENTIONED_USER = 'core/ADD_MENTIONED_USER';

export const addMentionedUser = (user: User) => ({
  type: CORE_ADD_MENTIONED_USER,
  user,
});

export const CORE_ADD_RELATED_USERS = 'core/ADD_RELATED_USERS';

/**
 * Users that came along a response as `meta.related.users` — e.g. the people a
 * chat message mentions, who need not be participants any more. Merges into the
 * store, so richer entries already there keep their extra fields.
 */
export const addRelatedUsers = (users: SimpleUser[]) => ({
  type: CORE_ADD_RELATED_USERS,
  items: users,
});

